import { DataCard } from '../../../components/DashboardCard';
import { useDeviceStates } from '../../../hooks/Dashboard/useDeviceStates';
import { DashboardData } from '../../../types/commonTypes';
import { useOperator } from '../../../contexts/OperatorContext';

export const DeviceStatusCard = (props: DashboardDeviceStatusCardProps) => {
  const { deviceType, theme } = props;
  const { deviceStates, getDeviceStates, loading } =
    useDeviceStates(deviceType);
  const { type } = useOperator();

  const handleRefresh = () => {
    getDeviceStates();
  };

  return (
    <DataCard
      data={deviceStates.reduce((arr: DashboardData[], s) => {
        const state = arr.find((a) => a.id === s.state);

        if (state) {
          state.value++;
        } else {
          arr.push({ id: s.state, value: 1 });
        }

        return arr;
      }, [])}
      title={`${deviceType} Status`}
      views={['basic', 'graph', 'list', 'pie']}
      columns={[
        { name: 'Status', dataKey: 'id' },
        { name: 'Count', dataKey: 'value', isNumeric: true },
      ]}
      exportColumns={[
        { name: 'Device Id', dataKey: 'deviceId' },
        { name: 'Mac Address', dataKey: 'macAddress' },
        { name: 'Status', dataKey: 'state' },
        {
          name: type === 'Hospitality' ? 'Room' : 'Account',
          dataKey: type === 'Hospitality' ? 'roomNumber' : 'accountNumber',
        },
        { name: 'Location', dataKey: 'location' },
      ]}
      exportData={deviceStates}
      exportTitle={`${deviceType} Status`}
      orientation="row"
      bottomLabel="State"
      leftLabel="Count"
      refresh={true}
      loading={loading}
      onRefresh={handleRefresh}
      theme={theme}
    />
  );
};
